import React from 'react';
import { CheckCircle, XCircle, Clock, Server } from 'lucide-react';
import { clsx } from 'clsx';
import { DnsResult } from '../types/dns';

interface DnsResultCardProps {
  result: DnsResult;
}

const DnsResultCard: React.FC<DnsResultCardProps> = ({ result }) => {
  const isSuccess = result.success;
  
  return (
    <div className={clsx(
      "p-4 rounded-lg border-2 transition-all duration-200",
      isSuccess 
        ? "bg-green-50 border-green-200 hover:border-green-300" 
        : "bg-red-50 border-red-200 hover:border-red-300"
    )}>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center space-x-2">
          {isSuccess ? (
            <CheckCircle className="w-5 h-5 text-green-600" />
          ) : (
            <XCircle className="w-5 h-5 text-red-600" />
          )}
          <span className="font-semibold text-gray-800">{result.isp}</span>
        </div>
        <div className="flex items-center space-x-1 text-sm text-gray-600">
          <Clock className="w-4 h-4" />
          <span>{result.duration}ms</span>
        </div>
      </div>
      
      <div className="space-y-1">
        <div className="flex items-center space-x-2 text-sm">
          <Server className="w-4 h-4 text-gray-500" />
          <span className="text-gray-600">{result.dnsServer}</span>
        </div>
        
        {isSuccess ? (
          <div className="text-sm">
            <span className="text-gray-600">Resolved to: </span>
            <span className="font-mono text-green-700 bg-green-100 px-2 py-1 rounded">
              {result.ip}
            </span>
          </div>
        ) : (
          <div className="text-sm text-red-600">
            Resolution failed: {result.error}
          </div>
        )}
      </div>
    </div>
  );
};

export default DnsResultCard;
